export default __webpack_public_path__ + "static/media/34.2a2ed61b.jpg";